import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import { selectWeatherIncompleteSprayEvents } from '../../../../selectors';

const selectWeatherFields = createDeepEqualSelector(
    selectWeatherIncompleteSprayEvents,
    (weatherIncompleteSprayEvents) =>
        weatherIncompleteSprayEvents.map(({ key }) => key)
);

export { selectWeatherFields };
